import { render, staticRenderFns } from "./SafeHouseRequestDetails.vue?vue&type=template&id=49c2ae98&scoped=true"
import script from "./SafeHouseRequestDetails.vue?vue&type=script&lang=ts"
export * from "./SafeHouseRequestDetails.vue?vue&type=script&lang=ts"
import style0 from "./SafeHouseRequestDetails.vue?vue&type=style&index=0&id=49c2ae98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c2ae98",
  null
  
)

export default component.exports